import styled from 'styled-components';

export const IconContainer = styled.div`
  width: 20px;
  display: flex;
`

export const ContaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .date {
    font-size: 14px;
  }

  .searchBarContainer {
    display: flex;
    gap: 16px;
    width: 100%;
  }

  .contentHeader {
    p, a {
      font-style: normal;
      line-height: 24px;
    }
  }

  .contentLink {
    display: flex;
    margin-top: 16px;

    svg {
      margin-right: 4px;
    }
  }

  .contentCard {
    margin-top: 20px;

    display: flex;
    gap: 24px;
  }

`;

export const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;

  .selectInput {
    grid-column: span 2;
  }

  align-items: end;
`;

export const Row = styled.tr<{ disabled?: 'S' | 'N' }>`
  color: ${({ disabled, theme }) =>
    disabled === 'N' ? theme.colors.gray[500] : ''};

  td {
    &:nth-child(10n) {
      color: ${({ disabled, theme }) =>
        disabled === 'N' ? theme.colors.gray[500] : ''};
    }
  }
`;

export const Td = styled.td`
  a {
    font-weight: 700;
    color: inherit;
    text-decoration: inherit;
    color: ${({ theme }) => theme.colors.orange.primary};

    transition: filter 0.2s ease-in;

    &:hover {
      filter: brightness(0.8);
    }
  }

  &:nth-child(6n),
  &:nth-child(7n),
  &:nth-child(8n),
  &:nth-child(9n),
  &:nth-child(10n) {
    font-weight: 600;
  }

  &:nth-child(10n) {
    color: ${({ theme }) => theme.colors.blue.primary};
  }

  &:nth-child(2) {
    white-space: nowrap;
    min-width: 132px;
  }
`;

export const DownloadContent = styled.a`
  display: flex;

  color: ${({ theme }) => theme.colors.gray[900]};

  font-weight: 600;
  font-size: 14px;
`;
